
import Vue from 'vue';
import Signup from "./ns-signup-vue/ns-signup-vue.vue";

const Components = {
  NsLoyaltySignup: Signup
};

Object.keys(Components).forEach((name) => {
  Vue.component(name, Components[name]);
});

export const NsLoyaltySignup = Signup
